import { Button, Group, Modal, Text } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import { useImpersonateUser } from "api/superAdmin/userSuperAdminId";

interface User {
  id: string;
  userName: string;
}

type CreateProjectModalProps = {
  opened: boolean;
  onClose: () => void;
  loginUser: User;
};

function LoginModal({ opened, onClose, loginUser }: CreateProjectModalProps) {
  const { mutate, isLoading } = useImpersonateUser();
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Login User"
        onClose={onClose}
        ariaLabel="Close Login Modal"
      />

      <Text> Do You Want to Login {loginUser.userName} ? </Text>
      <Group position="right" spacing={20} mt={10}>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          type="submit"
          variant="filled"
          onClick={() => mutate(loginUser.id)}
        >
          Login
        </Button>
      </Group>
    </Modal>
  );
}

export default LoginModal;
